var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 渠道订单组件（Channel Analysis）
 */
import React, { useState, useMemo } from "react";
import { Segmented, Select } from "antd";
import { CompsChart } from "@ms/shared-components";
import { COMMON_CHART_SETTINGS } from "../RoomStatusRecently/config/index";
import { AXIS_LABEL_INTEGER } from "../../configs/tooltipCommon";
import { CHANNEL_ANALYSIS_SORT_OPTIONS } from "../../configs/selectOptionsConfig";
import { EmptyDataPlaceholder } from "../EmptyDataPlaceholder";
import { pickChannelAnalysisChart, } from "../../hooks/useChannelAnalysisBundleData";
var CHANNEL_LABELS = [
    "前台",
    "中央",
    "小程序",
    "官网",
    "OTA直连",
    "企业直连",
];
function ensureCategoriesAreLabels(categories) {
    if (!(categories === null || categories === void 0 ? void 0 : categories.length))
        return [];
    var looksNumeric = categories.every(function (c) {
        return typeof c === "number" ||
            (typeof c === "string" && /^-?\d+(\.\d+)?$/.test(c));
    });
    var labels = looksNumeric
        ? categories.map(function (_, i) { var _a; return (_a = CHANNEL_LABELS[i]) !== null && _a !== void 0 ? _a : "\u6E20\u9053".concat(i + 1); })
        : categories.map(String);
    return labels;
}
var DEFAULT_CHART_DATA = {
    categories: [],
    dataset: { roomNights: [], rates: [], revenue: [] },
    axes: {
        left: {
            id: "left",
            position: "left",
            name: "间夜数",
            unit: "间",
            min: 0,
            max: 100,
            axisLabel: AXIS_LABEL_INTEGER,
        },
        right: {
            id: "right",
            position: "right",
            name: "收入",
            unit: "元",
            min: 0,
            max: 10000,
            axisLabel: AXIS_LABEL_INTEGER,
        },
    },
    series: [],
};
var ChannelAnalysis = function (_a) {
    var style = _a.style, bundle = _a.bundle, _b = _a.loading, loading = _b === void 0 ? false : _b, onTitleClick = _a.onTitleClick, titleLeftAdornment = _a.titleLeftAdornment;
    var _c = useState("7d"), range = _c[0], setRange = _c[1];
    var _d = useState("按间夜数排序"), sortType = _d[0], setSortType = _d[1];
    var baseChartData = useMemo(function () {
        var _a;
        var raw = (_a = pickChannelAnalysisChart(bundle, range)) !== null && _a !== void 0 ? _a : DEFAULT_CHART_DATA;
        var labels = ensureCategoriesAreLabels(raw.categories);
        var categories;
        if (labels.length === CHANNEL_LABELS.length) {
            categories = __spreadArray([], CHANNEL_LABELS, true);
        }
        else if (labels.length > 0) {
            categories = __spreadArray([], labels, true);
        }
        else {
            categories = [];
        }
        var axes = raw.axes;
        var withLabel = function (ax) {
            return ax && typeof ax === "object"
                ? __assign(__assign({}, ax), { axisLabel: AXIS_LABEL_INTEGER }) : ax;
        };
        var bottomAxis = (axes === null || axes === void 0 ? void 0 : axes.bottom) == null || typeof axes.bottom !== "object"
            ? {
                id: "bottom",
                position: "bottom",
                axisLabel: { interval: 0, show: true },
            }
            : __assign(__assign({}, axes.bottom), { axisLabel: { interval: 0, show: true } });
        return __assign(__assign({}, raw), { categories: categories, dataset: raw.dataset ? __assign({}, raw.dataset) : raw.dataset, axes: axes
                ? __assign(__assign(__assign(__assign({}, axes), (axes.left == null ? {} : { left: withLabel(axes.left) })), (axes.right == null ? {} : { right: withLabel(axes.right) })), { bottom: bottomAxis }) : raw.axes });
    }, [bundle, range]);
    var sortedChartData = useMemo(function () {
        var _a, _b, _c;
        var data = baseChartData;
        var roomNights = (_a = data === null || data === void 0 ? void 0 : data.dataset) === null || _a === void 0 ? void 0 : _a.roomNights;
        var revenue = (_b = data === null || data === void 0 ? void 0 : data.dataset) === null || _b === void 0 ? void 0 : _b.revenue;
        if (!(roomNights === null || roomNights === void 0 ? void 0 : roomNights.length) || !(revenue === null || revenue === void 0 ? void 0 : revenue.length))
            return data;
        var n = roomNights.length;
        var indices = Array.from({ length: n }, function (_, i) { return i; });
        if (sortType === "按间夜数排序") {
            indices.sort(function (a, b) { var _a, _b; return ((_a = roomNights[b]) !== null && _a !== void 0 ? _a : 0) - ((_b = roomNights[a]) !== null && _b !== void 0 ? _b : 0); });
        }
        else if (sortType === "按收入排序") {
            indices.sort(function (a, b) { var _a, _b; return ((_a = revenue[b]) !== null && _a !== void 0 ? _a : 0) - ((_b = revenue[a]) !== null && _b !== void 0 ? _b : 0); });
        }
        var sortedCategories = indices.map(function (i) { var _a; return (_a = CHANNEL_LABELS[i]) !== null && _a !== void 0 ? _a : "\u6E20\u9053".concat(i + 1); });
        return __assign(__assign({}, data), { categories: __spreadArray([], sortedCategories, true), dataset: {
                roomNights: indices.map(function (i) { return roomNights[i]; }),
                rates: ((_c = data.dataset) === null || _c === void 0 ? void 0 : _c.rates)
                    ? indices.map(function (i) { return data.dataset.rates[i]; })
                    : undefined,
                revenue: indices.map(function (i) { return revenue[i]; }),
            }, axes: data.axes, series: data.series });
    }, [baseChartData, sortType]);
    var hasChartData = sortedChartData &&
        Array.isArray(sortedChartData.series) &&
        sortedChartData.series.length > 0 &&
        Array.isArray(sortedChartData.categories) &&
        sortedChartData.categories.length > 0;
    return (_jsxs("div", __assign({ "data-component-id": "chart:channel-analysis", style: __assign({ display: "flex", flexDirection: "column", width: 400, height: 300, border: "1px solid #f0f0f0", borderRadius: 4, background: "#fafafa", boxSizing: "border-box", overflow: "visible", flexShrink: 0 }, style) }, { children: [_jsxs("div", __assign({ style: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "8px 12px",
                    borderBottom: "1px solid #f0f0f0",
                    background: "#fff",
                    flexShrink: 0,
                } }, { children: [_jsxs("div", __assign({ style: {
                            display: "flex",
                            alignItems: "center",
                            flexShrink: 0,
                            minWidth: 0,
                        } }, { children: [titleLeftAdornment && (_jsx("div", __assign({ style: {
                                    marginLeft: -4,
                                    marginRight: 4,
                                    flexShrink: 0,
                                    display: "flex",
                                    alignItems: "center",
                                } }, { children: titleLeftAdornment }))), onTitleClick ? (_jsx("button", __assign({ type: "button", onClick: onTitleClick, style: {
                                    fontSize: 14,
                                    fontWeight: 500,
                                    color: "#333",
                                    cursor: "pointer",
                                    padding: 0,
                                    border: "none",
                                    background: "none",
                                }, title: "\u70B9\u51FB\u67E5\u770B\u6E20\u9053\u8BA2\u5355" }, { children: "\u6E20\u9053\u8BA2\u5355" }))) : (_jsx("div", __assign({ style: { fontSize: 14, fontWeight: 500, color: "#333" } }, { children: "\u6E20\u9053\u8BA2\u5355" })))] })), _jsxs("div", __assign({ style: { display: "flex", alignItems: "center", gap: 8 } }, { children: [_jsx(Segmented, { size: "small", value: range, onChange: function (v) { return setRange(v); }, options: [
                                    { label: "7天", value: "7d" },
                                    { label: "30天", value: "30d" },
                                    { label: "12个月", value: "12m" },
                                ] }), _jsx(Select, { value: sortType, onChange: setSortType, size: "small", options: CHANNEL_ANALYSIS_SORT_OPTIONS, style: { width: 120, fontSize: 12 } })] }))] })), _jsxs("div", __assign({ style: {
                    flex: 1,
                    minHeight: 0,
                    width: "100%",
                    padding: 0,
                    boxSizing: "border-box",
                    overflow: "visible",
                    position: "relative",
                    display: "flex",
                    height: "100%",
                    background: "#fff",
                } }, { children: [loading && _jsx(EmptyDataPlaceholder, { description: "\u52A0\u8F7D\u4E2D..." }), !loading && hasChartData && (_jsx(CompsChart, { type: "combo", data: sortedChartData, settings: COMMON_CHART_SETTINGS, style: { width: "100%", height: "100%" } })), !loading && !hasChartData && (_jsx(EmptyDataPlaceholder, { description: "\u6682\u65E0\u6570\u636E" }))] }))] })));
};
export default ChannelAnalysis;
